import { supabaseClient } from "supabase/supabase";

export const deleteEvent = async ({ uid }: { uid: string }) => {
  const query = supabaseClient.from("events").delete().eq("uid", uid);
  const { error } = await query;
  if (error) {
    throw error;
  }
  return null;
};
